import React from "react";
import { CoachReviewsFiltersProvider, useCoachReviewsFilters } from "./components/CoachReviewsFiltersContext";
import { ReviewsTable } from "./components/ReviewsTable";
import { ReviewsSplitView } from "./components/ReviewsSplitView";
import { useCoachReviewsInfiniteQuery } from "./components/useCoachReviewsInfiniteQuery";

export function Reviews() {
  return (
    <CoachReviewsFiltersProvider>
      <ReviewsContent />
    </CoachReviewsFiltersProvider>
  );
}

function ReviewsContent() {
  const { reviewId, setReviewId } = useCoachReviewsFilters();
  // Keep the infinite query mounted across table ↔ split switches so cached pages are reused.
  const reviewsQuery = useCoachReviewsInfiniteQuery();

  return reviewId ? (
    <ReviewsSplitView
      reviewsQuery={reviewsQuery}
      selectedReviewId={reviewId}
      onSelectedReviewIdChange={setReviewId}
      onClose={() => setReviewId(null)}
    />
  ) : (
    <ReviewsTable reviewsQuery={reviewsQuery} onRowClick={review => setReviewId(String(review.id))} />
  );
}
